export default __webpack_public_path__ + "static/media/invalid-batch.a7926fcf.svg";